import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { Alert } from '@/components/Icons'

import './index.scss'

/**
 *  @example
 *   <ValidationWarning message={messages.validationWarning}>
 */

const ValidationWarning = ({ message }: any) => (
  <div className="validation-warning">
    <Alert className="validation-icon" />
    <FormattedMessage {...message} />
  </div>
)

ValidationWarning.displayName = 'ValidationWarning'
ValidationWarning.propTypes = { message: PropTypes.object }
ValidationWarning.defaultProps = { message: {} }

export default ValidationWarning
